import { Link } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import storeKeys from "../data/storeKeys";


const Complete = ({ session }) => {
    const [sessionId, setSessionId] = useState( "" );
    const [sessionEnded, setSessionEnded] = useState( false );

    const endSession = (data) => {
      console.log(data)
        try {
              fetch( process.env.REACT_APP_API_URL + 'session/end',{
                  method: 'POST',
                  headers: {
                    'Accept' : 'application/json',
                    'Content-Type' : 'application/json' 
                },
        
                body : JSON.stringify(data)            
              })
              .then(res => res.json())
              .then(data => {console.log(data)}
              )
          }catch(error){
            console.log("Failed to end session", data)
          }
          return true;  
    }

    useEffect(() => {
      if(session !== null && !sessionEnded) {
        window.localStorage.setItem(storeKeys.CurrentCard, "-");
        setSessionEnded(true)
        setSessionId(session.sessionId)
        endSession({'session':session.sessionId});
      }
    },[sessionEnded,session])

    return (
    <div>
        <h1>Survey Complete</h1>
        <p>TODO - Thankyou</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
        
        <p>Remember your session id: <b>{sessionId}</b> in order to manage your data</p>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
        <Link to="/">Home</Link>
        
    </div>
    );
  };
  
  export default Complete;